// extracted by mini-css-extract-plugin
export default {"filters":"style--filters--332519","filter":"style--filter--3fdfc6"};